import * as React from 'react'
import {
  siteIntegrationDdcCollectVehicleInfoSelector,
  siteIntegrationDdcEnglishSelector,
  siteIntegrationDdcFrenchSelector,
  siteIntegrationDdcHideEpSelector,
  siteIntegrationDdcSpanishSelector,
  siteIntegrationDdcUseAgentSelector, siteIntegrationDebugSelector,
  siteIntegrationGenericJavascriptSelector,
  siteIntegrationTypeSelector
} from 'state/ui'
import { RootState } from 'state/reducer'
import { SiteIntegrationType } from 'types/SiteIntegrationInterface'
import { connect } from 'react-redux'

export interface Props {
  integrationType?: string
  debug: boolean,
  ddcEnglish?: string
  ddcSpanish?: string
  ddcFrench?: string
  ddcCollectVehicleInfo?: boolean
  ddcHideEp?: boolean
  ddcUseAgent?: boolean
  genericJavascript?: string
}

const mapStateToProps = (state: RootState): Props => ({
  integrationType: siteIntegrationTypeSelector(state),
  debug: siteIntegrationDebugSelector(state),
  ddcEnglish: siteIntegrationDdcEnglishSelector(state),
  ddcSpanish: siteIntegrationDdcSpanishSelector(state),
  ddcFrench: siteIntegrationDdcFrenchSelector(state),
  ddcCollectVehicleInfo: siteIntegrationDdcCollectVehicleInfoSelector(state),
  ddcHideEp: siteIntegrationDdcHideEpSelector(state),
  ddcUseAgent: siteIntegrationDdcUseAgentSelector(state),
  genericJavascript: siteIntegrationGenericJavascriptSelector(state)
})

class SiteIntegration extends React.Component<Props> {
  public componentDidMount() {
    if (this.props.integrationType === SiteIntegrationType.DEALER_DOT_COM) {
      const {
        debug,
        ddcEnglish,
        ddcSpanish,
        ddcFrench,
        ddcCollectVehicleInfo,
        ddcHideEp,
        ddcUseAgent
      } = this.props
      window.top.postMessage(
        {
          type: 'initIntegration',
          settings: {
            type: 'ddc',
            debug: !!debug,
            chat: {
              buttonText: {
                en_US: ddcEnglish,
                es: ddcSpanish,
                fr_CA: ddcFrench
              },
              collectVehicleInfo: !!ddcCollectVehicleInfo,
              useAgent: !!ddcUseAgent,
              hideEp: !!ddcHideEp
            }
          }
        },
        '*'
      )
    } else if (this.props.integrationType === SiteIntegrationType.GENERIC) {
      const { debug, genericJavascript } = this.props
      window.top.postMessage(
        {
          type: 'initIntegration',
          settings: {
            type: 'generic',
            debug: !!debug,
            javascript: genericJavascript
          }
        },
        '*'
      )
    }
  }

  public render() {
    return false
  }
}

export const SiteIntegrationContainer = connect(mapStateToProps)(
  SiteIntegration
)
